import React from 'react';
import { connect } from "react-redux";
import createUser from './../../../API/Admin/CreateUser.js'
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import Loader from './../../../Global/loader'

class CreateUser extends React.Component {
    constructor(props) {
        super(props); 
        this.submitCreate = this.submitCreate.bind(this);
    }

    state={
        loading: true,
        username: "",
        password: "",
        email: "",
        firstName: "",
        lastName: "",        
        role: []
    }

    componentDidMount = async () => {
        this.setState({
            loading: true
        })       

        this.setState({            
            loading: false
        }) 
    }

    
    handleChange(e){
        this.setState({
            [e.target.id]: e.target.value
        })
    }
   

    submitCreate = async (e) => {
        this.setState({ loading: true })
        e.preventDefault()
        let createNewUser = await createUser(
            this.props.oneClientInfo.uuid, 
            this.state.username,
            this.state.password,
            this.state.email,
            this.state.firstName,
            this.state.lastName,        
            this.state.role
        )
        
        if(createNewUser.data.status !== 201){ 
            store.addNotification({
                title: "Greška!",
                message: createNewUser.data.message,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })

            this.setState({ loading: false })
        }
        else{
            store.addNotification({
                title: "Uspješno!",
                message: "Kreiranje korisnika je završeno",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });

            this.props.goBack()
        }        
    }
   
    render(){  
        return (
            <>
                {this.state.loading ?
                <div style={{position: "sticky", marginTop: "50px", left: "50%"}}>
                    <Loader />
                </div>
                :
                <form style={{padding: "40px"}}>
                    <div className="row">          
                        <div className="col col-sm-12 col-lg-6 col-md-12">
                            <div className="form-group row">
                                <label htmlFor="username" className="col-sm-4 col-form-label">Korisničko ime</label>
                                <div className="col-sm-8">
                                    <input      
                                            id="username"                          
                                            type="text"
                                            value={this.state.username}
                                            onChange={e => this.handleChange(e)}
                                        />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="password" className="col-sm-4 col-form-label">Lozinka</label>
                                <div className="col-sm-8">
                                    <input
                                        id="password"  
                                        type="text"
                                        value={this.state.password}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="email" className="col-sm-4 col-form-label">E-mail</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="email"                         
                                        type="text"
                                        value={this.state.email}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </div>
                            </div>  

                            <div className="form-group row">
                                <label htmlFor="firstName" className="col-sm-4 col-form-label">Ime</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="firstName"                         
                                        type="text"
                                        value={this.state.firstName}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </div>
                            </div> 

                            <div className="form-group row">
                                <label htmlFor="lastName" className="col-sm-4 col-form-label">Prezime</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="lastName"                         
                                        type="text"
                                        value={this.state.lastName}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </div>
                            </div> 


                            <div className="col-sm-4" style={{float:"right",padding: "0px"}}>
                                <button                                    
                                    className="btn btn-info" 
                                    style={{padding:"10px"}} 
                                    onClick={(e) => this.submitCreate(e)}
                                >
                                    Spremi
                                </button>
                            </div>                                  
                        </div>                        
        
                        
                    </div>           
                    
                    <div 
                        className="btn btn-default" 
                        style={{/*width: "100%",*/ marginBottom: "10px", marginTop: "10px"}}
                        onClick={() => this.props.goBack()}
                    >
                        <BsBackspaceFill size={30} />  <strong>Nazad</strong>
                    
                    </div>    
                
                </form>
                }  
            </>

        )
    }
}
const mapStateToProps = state => {
    return {
        oneClientInfo: state.adminClient.oneClient,
        posProstorList: state.adminClient.posProstorList,
        onePosPro: state.adminClient.onePosPro
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(CreateUser);


